import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { handleBlockedClick } from '../../config/blockedRoutes';

const socialLinks = [
  { icon: 'kakao', href: 'https://pf.kakao.com/_JScZX/friend', label: 'KakaoTalk' },
  { icon: 'whatsapp', href: 'https://wa.me/821022500365', label: 'WhatsApp' },
  { icon: 'line', href: 'https://line.me/R/ti/p/@690ljwok', label: 'Line' },
  { icon: 'linkedin', href: 'https://www.linkedin.com/company/vipvantour/about/', label: 'LinkedIn' },
  { icon: 'instagram', href: 'https://www.instagram.com/vipvantour.korea/', label: 'Instagram' },
  { icon: 'facebook', href: 'https://www.facebook.com/profile.php?id=61573357626146', label: 'Facebook' },
];

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-mono-900 text-white">
      <div className="max-w-container mx-auto px-5 lg:px-20 py-8 lg:py-10">
        {/* Logo + Social Icons */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <img src="/images/logo/logo2.png" alt="VIP VAN TOUR" loading="lazy" className="h-5 sm:h-6 w-auto self-start brightness-0 invert" />
          <div className="flex items-center gap-2.5">
            {socialLinks.map((s) => (
              <a
                key={s.icon}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center transition hover:bg-white/30"
              >
                <Icon name={s.icon} size={20} className="text-white/80" />
              </a>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 my-5" />

        {/* 실선 아래: 모두 세로 나열 */}
        <div className="flex flex-col gap-2.5">
          <Link to="/faq" onClick={(e) => handleBlockedClick(e, '/faq')} className="text-sm font-bold hover:text-white/80 transition">{t('footer.support')}</Link>
          <Link to="/partnership" onClick={(e) => handleBlockedClick(e, '/partnership')} className="text-sm font-bold hover:text-white/80 transition">{t('footer.partnership')}</Link>
          <Link to="/about" onClick={(e) => handleBlockedClick(e, '/about')} className="text-sm font-bold hover:text-white/80 transition">{t('footer.about')}</Link>
        </div>

        <div className="mt-5 flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 sm:gap-0 text-xs text-mono-200">
          <Link to="/policy/service" className="hover:text-white/80">{t('footer.terms')}</Link>
          <span className="hidden sm:inline text-mono-500 mx-3">|</span>
          <Link to="/policy/privacy" className="hover:text-white/80">{t('footer.privacy')}</Link>
          <span className="hidden sm:inline text-mono-500 mx-3">|</span>
          <Link to="/policy/marketing" className="hover:text-white/80">{t('footer.marketing')}</Link>
          <span className="hidden sm:inline text-mono-500 mx-3">|</span>
          <Link to="/policy/refund" className="hover:text-white/80">{t('footer.refund')}</Link>
        </div>

        <div className="mt-6 text-2xs sm:text-xs text-mono-400 leading-relaxed break-keep space-y-1">
          <p>{t('footer.company_name')} | {t('footer.ceo')} 백정엽</p>
          <p>{t('footer.company_address')}&nbsp;&nbsp;{t('footer.phone')}: 010-2250-0365</p>
          <p>{t('footer.business_number')}: 145-88-01687 | {t('footer.tourism_registration')}</p>
          <p>{t('footer.ecommerce_registration')}</p>
        </div>
      </div>
    </footer>
  );
}
